import {ChangeDetectionStrategy, ChangeDetectorRef, Component, computed, effect, inject, signal} from '@angular/core';
import {AsyncPipe} from '@angular/common';
import {DeviceService} from '../../ngm-dev-blocks/utils/services';
import {LanguageService} from '../../service/language.service';

interface FooterLink {
  label: string;
  url: string;
}

@Component({
  selector: 'app-footer',
  imports: [
    AsyncPipe,
  ],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FooterComponent {
  private deviceService = inject(DeviceService);
  private langService = inject(LanguageService);
  private cdr = inject(ChangeDetectorRef);

  constructor() {
    effect(() => {
      this.langService.currentLang();
      this.cdr.markForCheck();
    });
  }

  // Device observables
  isHandset$ = this.deviceService.isHandset$;
  isTablet$ = this.deviceService.isTablet$;
  isLessThanMD$ = this.deviceService.isLessThanMD$;

  address = signal('42 Rue Ibn Hilal, Menzel 5, Tunis');

  navigationLinks = computed<FooterLink[]>(() => this.langService.get('footer.nav_links'));
  servicesLinks = computed<FooterLink[]>(() => this.langService.get('footer.service_links'));

  navTitle = computed(() => this.langService.translate('footer.nav_title'));
  servicesTitle = computed(() => this.langService.translate('footer.services_title'));
  desc1 = computed(() => this.langService.translate('footer.desc1'));
  desc2 = computed(() => this.langService.translate('footer.desc2'));
  desc3 = computed(() => this.langService.translate('footer.desc3'));
  copyright = computed(() => this.langService.translate('footer.copyright'));

  socialLinks = signal([
    { name: 'Facebook', url: '#', icon: 'facebook' },
    { name: 'Instagram', url: '#', icon: 'instagram' },
    { name: 'YouTube', url: '#', icon: 'youtube' },
  ]);

  currentYear = signal(new Date().getFullYear());
}
